module.exports = __webpack_public_path__ + "static/media/Blue-Gradient-Bk.0f91da98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Blue-Gradient-Bk.jpg
// module id = 412
// module chunks = 0